<span class="d-block">Item Number: {{ itemNumber }}
    <ng-container *ngIf="hsCode">
        <span class="pl-4">HS Code: {{ hsCode }}</span>
        <span class="pl-4">This item is in scope of EUDR</span>
    </ng-container>
</span>
<span *ngIf="showProductCode && supplierId" class="d-block">{{ supplierLabel }}:&nbsp;{{ supplierId }}</span>
